import p from "./index.es299.js";
function C(e, s) {
  var t = s.schema, o = [];
  if (t)
    return {
      data: e,
      mergedCells: o
    };
  for (var c = function() {
    e = e.slice();
    for (var h = 0; h < e.length; )
      e[h] = e[h].slice(), h++;
    return c = function() {
      return e;
    }, e;
  }, i = 0; i < e.length; ) {
    for (var u = e[i], n = 0; n < u.length; ) {
      var r = u[n];
      if (r) {
        var a = r.span, l = a === void 0 ? 1 : a, v = r.rowSpan, d = v === void 0 ? 1 : v;
        (l > 1 || d > 1) && (w({
          data: e,
          rowIndex: i,
          columnIndex: n,
          span: l,
          rowSpan: d,
          cloneData: c
        }), o.push([[i, n], [i + (d ? d - 1 : 0), n + (l ? l - 1 : 0)]]));
      }
      n++;
    }
    i++;
  }
  return {
    data: e,
    mergedCells: o
  };
}
function w(e) {
  var s = e.data, t = e.rowIndex, o = e.columnIndex, c = e.span, i = e.rowSpan, u = e.cloneData, n = p(s[t][o]);
  n && (s = u());
  for (var r = t; r <= t + (i - 1); ) {
    for (var a = o; a <= o + (c - 1); ) {
      var l = s[r][a];
      if (r > t || a > o) {
        if (l != null)
          throw new Error("[write-excel-file] When using `span` or `rowSpan` parameters, all hidden overlapped cells should be represented by `null`s or `undefined`s. Cell at row ".concat(t + 1, " and column ").concat(o + 1, " is configured with `span` ").concat(c, " and `rowSpan` ").concat(i, ". Cell at row ").concat(r + 1, " and column ").concat(a + 1, " is neither `null` nor `undefined`: ").concat(JSON.stringify(l)));
        n && (s[r][a] = n);
      }
      a++;
    }
    r++;
  }
}
export {
  C as default
};
//# sourceMappingURL=index.es266.js.map
